export default __webpack_public_path__ + "static/media/first-prototype.6ed23ac5.png";